import AxiosWrapper from "./axios";


const UserService = () => {
    const client = new AxiosWrapper()

    const checkUserAvailability = async (username, applicantId) => {
        return await client.get(`check-user-availability?username=${username}&referenceNumber=${applicantId}`);
    };

    const createUser =  async (applicantId) => {
        return await client.post('create-account',
        {
            username: sessionStorage.getItem('username'),
            password: sessionStorage.getItem('password'),
            system: '',
            applicantId: applicantId,
            registrationReferenceType: 1
        }, true);
    };

    const validateUserExists =  async (applicantId) => {
        return await client.post('validate-user-exists',
        {
            referenceNumber: applicantId,
            source: "AppS",
            from: "ApplicantPlatform"
        }, true);
    };

    const setUser = (obj) => 
    {
        const key = Object.keys(obj)[0];
        const value = Object.values(obj)[0];
        sessionStorage.setItem(key, value);
    }

    return {
        checkUserAvailability,
        createUser,
        setUser,
        validateUserExists,
    }
}

export default UserService;